export default __webpack_public_path__ + "static/media/loading.b3e6959d.png";